import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LogIn, Menu, UserPlus, X } from 'lucide-react';
import { BrandMark } from '@/components/common/BrandMark';
import { LANDING_NAV_ITEMS } from '@/constants/landing.constants';

export function LandingHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 z-50 border-b border-neutral-200/80 bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:h-[4.5rem] sm:px-6 lg:px-8">
        <a href="/#inicio" className="shrink-0" onClick={closeMenu}>
          <BrandMark size="sm" imageClassName="h-10 w-auto max-h-10 sm:h-12 sm:max-h-12" />
        </a>

        <nav
          data-testid="landing-desktop-nav"
          className="hidden items-center gap-6 lg:flex"
          aria-label="Seções da landing"
        >
          {LANDING_NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-medium text-neutral-700 transition-colors hover:text-teal-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <AuthLinks className="hidden lg:flex" />
          <button
            type="button"
            className="inline-flex size-10 items-center justify-center rounded-lg border border-neutral-200 text-neutral-800 lg:hidden"
            aria-expanded={menuOpen}
            aria-controls="landing-mobile-nav"
            aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
          </button>
        </div>
      </div>

      {menuOpen ? (
        <nav
          id="landing-mobile-nav"
          data-testid="landing-mobile-nav"
          className="border-t border-neutral-200 bg-white px-4 py-4 lg:hidden"
          aria-label="Menu mobile"
        >
          <ul className="flex flex-col gap-1">
            {LANDING_NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-neutral-800 hover:bg-teal-50 hover:text-teal-800"
                  onClick={closeMenu}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <AuthLinks className="mt-4 grid grid-cols-2 gap-2 border-t border-neutral-200 pt-4" onNavigate={closeMenu} />
        </nav>
      ) : null}
    </header>
  );
}

interface AuthLinksProps {
  className?: string;
  onNavigate?: () => void;
}

function AuthLinks({ className = 'flex', onNavigate }: AuthLinksProps) {
  return (
    <div className={`items-center gap-2 ${className}`}>
      <Link
        to="/login"
        className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-neutral-300 bg-white px-2.5 py-2 text-sm font-medium text-neutral-800 transition-colors hover:bg-neutral-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2 sm:px-3.5"
        onClick={onNavigate}
      >
        <LogIn className="size-4" aria-hidden />
        Entrar
      </Link>
      <Link
        to="/register"
        className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-teal-700 px-2.5 py-2 text-sm font-medium text-white transition-colors hover:bg-teal-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2 sm:px-3.5"
        onClick={onNavigate}
      >
        <UserPlus className="size-4" aria-hidden />
        Criar conta
      </Link>
    </div>
  );
}
